module.exports = __webpack_public_path__ + "static/media/network_logo.debc707d.png";